import * as React from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

const IconClose = ({ onClick }) => {
  return (
    <Box>
      <CloseIcon
        onClick={() => onClick()}
        sx={{
          fontWeight: "100",
          cursor: 'pointer',
          ":hover": {
            backgroundColor: "transparent",
            transform: "rotate(90deg)",
          },
          color: "#fff",
          transition: "transform 1s",
        }} 
      />
    </Box>
  )
}

export default IconClose;